module.exports = __webpack_public_path__ + "static/media/line_chart_up.3a761677.svg";